import { AlertCircle, Check } from "lucide-react";
import { PxMark } from "@/components/PxMark";

/**
 * Écran d'état plein écran — OFFSET.
 * Partagé par les pages de callback OAuth (GitHub / Netlify / Supabase) :
 * en cours (px-mark thinking) / succès (Check ok) / erreur (AlertCircle err).
 */
export type StatusScreenStatus = "loading" | "success" | "error";

interface StatusScreenProps {
  status: StatusScreenStatus;
  /** Titre Geist (H3, sentence case). */
  title: string;
  /** Méta technique sous le titre : détail, message d'erreur… (mono 11). */
  meta?: string;
  /** Action optionnelle en lien ghost. */
  action?: { label: string; onClick: () => void };
}

export function StatusScreen({ status, title, meta, action }: StatusScreenProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="w-full max-w-sm border border-hairline-strong bg-card p-8 text-center">
        <div className="mb-4 flex justify-center" aria-hidden="true">
          {status === "loading" && <PxMark state="thinking" size={24} />}
          {status === "success" && <Check className="h-6 w-6 text-ok" />}
          {status === "error" && <AlertCircle className="h-6 w-6 text-err" />}
        </div>
        <h1 className="text-base font-medium text-foreground">{title}</h1>
        {meta && (
          <p className="mt-2 break-words font-mono text-[11px] leading-relaxed text-faint">
            {meta}
          </p>
        )}
        {action && (
          <button
            type="button"
            onClick={action.onClick}
            className="mt-6 text-[13px] text-muted-foreground underline-offset-[3px] transition-colors hover:text-foreground hover:underline"
          >
            {action.label}
          </button>
        )}
      </div>
    </div>
  );
}
